<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-dialog
          scrollable
          v-model="sendEmailsDialog"
          persistent
          max-width="1800"
        >
          <material-card
            :title="sendEmailsDialogTitle()"
            icon="file_copy"
            :color="$vuetify.theme.themes.light.secondary"
          >
            <v-card-text v-if="sendEmailsDialog">
              <send-emails :recipients="recipients" />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn text @click="closeSendEmailsDialog()">
                {{ $t("globals.close") }}
              </v-btn>
              <v-btn
                @click="handleSendReports"
                :loading="loading"
                :disabled="loading"
                dark
                color="success"
              >
                {{ $t("components.sendemails.send") }}
              </v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
        <v-dialog
          scrollable
          v-model="getReportsDialog"
          persistent
          max-width="1800"
        >
          <material-card
            :title="reportsDialogTitle()"
            icon="file_copy"
            :color="$vuetify.theme.themes.light.secondary"
          >
            <v-card-text v-if="getReportsDialog">
              <get-reports
                ref="getReports"
                :calculationEntity="calculationEntity"
                :term="selectedTerm"
                :reportId="reportId"
                v-if="
                  calculationEntity !== null &&
                    calculationEntity !== undefined &&
                    selectedTerm !== null &&
                    selectedTerm !== undefined
                "
                :hasEnhancedBillingReport="hasEnhancedBillingReport"
              ></get-reports>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" @click="closeGetReportsDialog()">
                {{ $t("globals.close") }}
              </v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
        <v-dialog
          scrollable
          v-model="getRecapReportsDialog"
          persistent
          max-width="1800"
        >
          <material-card
            :title="$t('components.archivetable.get_recap_reports')"
            icon="file_copy"
            :color="$vuetify.theme.themes.light.secondary"
          >
            <v-card-text v-if="getRecapReportsDialog">
              <get-reports
                ref="getReports"
                :calculationEntity="calculationEntity"
                :term="selectedTerm"
                :reportId="reportId"
                :isRecap="true"
                v-if="selectedTerm && reportId"
              />
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn color="primary" @click="closeGetRecapReportsDialog()">
                {{ $t("globals.close") }}
              </v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
        <v-dialog
          scrollable
          v-model="getPaymentsDialog"
          persistent
          max-width="1800"
        >
          <material-card
            :title="$t('components.archivetable.get_payment_title')"
            icon="file_copy"
            :color="$vuetify.theme.themes.light.secondary"
          >
            <v-card-text v-if="getPaymentsDialog">
              <!-- <get-reports
                ref="getReports"
                :calculationEntity="calculationEntity"
                :term="selectedTerm"
                :reportId="reportId"
                v-if="
                  calculationEntity !== null &&
                    calculationEntity !== undefined &&
                    selectedTerm !== null &&
                    selectedTerm !== undefined
                "
              ></get-reports> -->
              <payment-schedule-report
                :term="selectedTerm"
                :reportId="reportId"
              ></payment-schedule-report>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" @click="closeGetPaymentsDialog()">
                {{ $t("globals.close") }}
              </v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
      </v-row>
    </v-container>
    <material-card
      :title="
        $t('components.archivetable.{0}_archive', [
          $t('components.archivetable.' + calculationEntity),
        ])
      "
      :color="$vuetify.theme.themes.light.secondary"
      :icon="icon"
    >
      <pbas-data-table
        :exporters="$exporters"
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        fileNamePrefix="billing"
        :sortBy="'BillingTerm/Name'"
        :sortDescending="true"
        :identifier="identifier"
        @error="error = $event"
      ></pbas-data-table>
      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :multi-line="snackbarMode === 'multi-line'"
        :timeout="snackbarTimeout"
        :vertical="snackbarMode === 'vertical'"
      >
        {{ $t(snackbarMessage) }}
        <v-btn dark text @click="snackbar = false">
          {{ $t("globals.close") }}
        </v-btn>
      </v-snackbar>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import GetReports from "../components/GetReports";
import getHeaders from "../headers/Archive";
import SendEmails from "./SendEmails.vue";
import PaymentScheduleReport from "../components/PaymentScheduleReport";
import ErrorHandler from "../components/ErrorHandler";
import { sortAlphanum } from "../alphanumericSort";

export default {
  name: "archive-table",
  components: { GetReports, SendEmails, PaymentScheduleReport, ErrorHandler },
  props: ["icon", "calculationEntity", "url", "identifier"],
  async mounted() {
    this.loadPlanData();
  },
  data: function() {
    return {
      getPaymentsDialog: false,
      rowActions: [
        {
          name: "getReports",
          icon: "file_copy",
          title: "components.archivetable.get_reports",
          handler: this.getReportsHandler,
        },
        {
          name: "getRecapReports",
          icon: "file_copy",
          title: "components.archivetable.get_recap_reports",
          handler: this.getRecapReportsHandler,
          visible: () =>
            this.calculationEntity === "Commissions"
        },
        {
          name: "sendEmails",
          icon: "email",
          title: "components.sendemails.send",
          handler: this.sendEmailsHandler,
          visible: () =>
            this.role.indexOf("Broker Plan Manager") > -1 ||
            this.role.indexOf("Broker Plan Admin") > -1,
        },
        {
          name: "getPaymentScheduleReport",
          icon: "file_copy",
          title: "components.archivetable.payment_schedule",
          handler: this.getPaymentHandler,
          visible: () =>
            this.calculationEntity === "Billing" &&
            (this.role.indexOf("Broker Plan Manager") > -1 ||
              this.role.indexOf("Broker Plan Admin") > -1),
        },
      ],
      confirmReviseDialog: false,
      error: null,
      getReportsDialog: false,
      getRecapReportsDialog: false,
      headers: [],
      loading: false,
      premiums: [],
      provider: undefined,
      recipients: [],
      reportId: null,
      saving: false,
      selectedItem: null,
      selectedTerm: null,
      sendEmailsDialog: false,
      snackbar: false,
      snackbarColor: "",
      snackbarMessage: "",
      snackbarMode: "",
      snackbarTimeout: 2500,
      yearId: null,
      hasEnhancedBillingReport: false
    };
  },
  computed: {
    ...mapGetters("common", ["messages", "settings", "language"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    formTitle() {
      return this.editedIndex === -1
        ? "components.archivetable.new_item"
        : "components.archivetable.edit_item";
    },
    odataUrl() {
      return this.url + "/reports/archive";
    },
  },
  methods: {
    ...mapActions("transactions", [
      "getRecipients",
      "sendBulkReportEmail",
    ]),
    ...mapActions("plansMembers", [
      "getEmployers",
      "getStores",
    ]),
    getPaymentHandler(item) {
      this.selectedTerm = {
        Id: item.BillingTerm.Id,
        Name: item.BillingTerm.Name,
        Item: item,
      };

      this.reportId = item.Id;
      this.getPaymentsDialog = true;
    },
    async handleSendReports() {
      var id = this.selectedItem.BillingTermId;
      var origin = window.location.origin;
      var planId = this.selectedPlan.Id;
      var calculation = this.calculationEntity;
      var reportId = this.selectedItem.Id;
      var url = encodeURI(
        `${origin}#/plan/${planId}/email-callback/${calculation}/${reportId}?redirect=true`
      );

      var payload = {
        BillingTermId: id,
        ReportUrl: url,
      };

      this.loading = true;
      try {
        await this.sendBulkReportEmail({ payload, planId });
        this.showSnackbar("Email Successfully Sent!", null, "success");
      } catch (error) {
        this.showSnackbar(
          "Error encountered while sending emails",
          null,
          "error"
        );
        // this.error = error;
      }
      this.loading = false;
      this.closeSendEmailsDialog();
    },
    sendEmailsDialogTitle: function() {
      return this.$t("components.archivetable.send_email");
    },
    reportsDialogTitle: function() {
      let transEntity = this.$t(
        "components.archivetable." + this.calculationEntity
      );
      if (transEntity === "Primes") transEntity = "sur les Primes";
      else if (transEntity === "Versements")
        transEntity = "sur les Envois de Fonds";
      else if (transEntity === "Facturation")
        transEntity = "sur les Facturation";
      return this.$t("components.archivetable.{0}_reports", [transEntity]);
    },
    recapReportsDialogTitle: function() {
      let transEntity = this.$t(
        "components.archivetable." + this.calculationEntity
      );
      if (transEntity === "Primes") transEntity = "sur les Primes";
      else if (transEntity === "Versements")
        transEntity = "sur les Envois de Fonds";
      else if (transEntity === "Facturation")
        transEntity = "sur les Facturation";
      return this.$t("components.archivetable.{0}_reports", [transEntity]);
    },
    showSnackbar(message, timeout, color) {
      this.snackbar = true;
      this.snackbarMessage = message || this.snackbarMessage;
      this.snackbarTimeout = timeout || this.snackbarTimeout;
      this.snackbarColor = color || this.snackbarColor;
    },
    loadPlanData() {
      this.headers = getHeaders(this.calculationEntity)
      this.provider = new PbasOData(
        this.$axiosHttp,
        this.odataUrl,
        this.headers
      );
    },
    getReportsHandler(item) {
      this.selectedTerm = {
        Id: item.BillingTerm.Id,
        Name: item.BillingTerm.Name,
        Item: item,
      };
      this.hasEnhancedBillingReport = false;
      if (item.Plan !== null && item.Plan !== undefined && item.Plan.ReportConfiguration !== null && item.Plan.ReportConfiguration !== undefined) {
        this.hasEnhancedBillingReport = item.Plan.ReportConfiguration.BillingReportType === "Enhanced"
      }
      this.reportId = item.Id;
      this.getReportsDialog = true;
    },
    // New handler for Recap Reports
    getRecapReportsHandler(item) {
      this.selectedTerm = {
        Id: item.BillingTerm.Id,
        Name: item.BillingTerm.Name,
        Item: item,
      };

      this.reportId = item.Id;
      this.getRecapReportsDialog = true;
    },
    async sendEmailsHandler(item) {
      try {
        const employers = (await this.getEmployers({
          plan: this.selectedPlan.Id,
        })).data.value.sort((a, b) => {
          const translatedA = a.Current.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name;
          const translatedB = b.Current.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name;
          console.log(translatedA, translatedB);
          return sortAlphanum(translatedA, translatedB);
        });
        const stores = (await this.getStores(
          this.selectedPlan.Id
        )).data.value.sort((a, b) => {
          const translatedA = a.Current.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name;
          const translatedB = b.Current.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name;
          console.log(translatedA, translatedB);
          return sortAlphanum(translatedA, translatedB);
        });
        this.recipients = (await this.getRecipients({
          planIdentityId: this.selectedPlan.Id,
          reportType: this.calculationEntity,
        })).data.value.map((r) => {
          return {
            FirstName: r.User.FirstName,
            LastName: r.User.LastName,
            Email: r.User.Email,
            Employers: employers
              .filter(
                (o) =>
                  r.UserReportSettingsEmployers.filter(
                    (oo) => oo.EmployerId === o.Id
                  ).length > 0
              )
              .map(
                (e) =>
                  e.Current.Translations.filter(
                    (o) => o.LanguageCode === this.language.language
                  )[0].Name
              )
              .join(", "),
            Branches: stores
              .filter(
                (o) =>
                  r.UserReportSettingsStores.filter((oo) => oo.StoreId === o.Id)
                    .length > 0
              )
              .map((s) => s.Store.Name)
              .join(", "),
          };
        });
        console.log(this.recipients);
        this.selectedItem = item;
        this.sendEmailsDialog = true;
      } catch (error) {
        this.error = error;
      }
    },
    closeGetReportsDialog() {
      this.$refs.getReports.reset();
      this.getReportsDialog = false;
    },
    closeGetRecapReportsDialog() {
      this.$refs.getReports.reset();
      this.getRecapReportsDialog = false;
    },
    closeSendEmailsDialog() {
      this.sendEmailsDialog = false;
    },
    closeGetPaymentsDialog() {
      this.getPaymentsDialog = false;
    },
  },
};
</script>
